export default __webpack_public_path__ + "static/media/Unionhead.0a37d94c.svg";